<template>
  <div>
    <pvd-footer
      v-if="showNbFooter"
      :us-only="usOnlyText"
      :links="content"
    >
      <net-benefits-footer />
    </pvd-footer>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import utility from '../mixins/utility';
import NetBenefitsFooter from './NetBenefitsFooter.vue';

export default {
  name: 'SiteFooter',
  components: {
    NetBenefitsFooter,
  },
  mixins: [dataHelper, utility],
  props: {
    usOnlyText: {
      type: String,
      default: '',
    },
    footerContent: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    content() {
      let links = {};
      if (this.footerContent) {
        links = this.footerContent;
      }
      return JSON.stringify(links);
    },
    showNbFooter() {
      return this.isNetBenefits();
    },
  },
};
</script>

<style scoped>

</style>
